/** Research guide §1 — Library & history (`research/ResearchLibraryView.tsx`). */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, HelpSectionCard, P, SectionLink, Shot, SubHead } from '../HelpPrimitives.js';

export function ResearchLibrary(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('research-library')}>
      <Shot
        slug="research-library"
        caption="The Library panel: company counters across the top, search below."
      />
      <P>
        The entry point to Research. A toggle switches between two panels; nothing here calls the AI
        — it&rsquo;s pure browsing.
      </P>

      <SubHead>Library</SubHead>
      <P>
        Two modes, switched next to the search box. <Btn>All companies</Btn> (the default) is every
        company the searches have ever found. <Btn>Approved only</Btn> shows just the companies
        someone approved and sent on — a company joins it when you press{' '}
        <Btn>Continue to publish</Btn> with it approved, and is never counted twice. The four
        counters at the top follow the mode: companies in library, cache hit-rate, industries
        covered, and how many were verified in the last 90 days. Use the <Btn>search</Btn> box to
        find one.
      </P>

      <SubHead>History</SubHead>
      <P>
        Past research requests, with their own search box and a status filter. Click{' '}
        <Btn>History</Btn> on a row to reopen it wherever it left off — on the run, review or
        request screen — or <Btn>Clone</Btn> to start a fresh request pre-filled from the same
        criteria.
      </P>

      <P>
        Either panel, click <Btn>New Research Request</Btn> to start one — see{' '}
        <SectionLink to="research-intake">Starting a research request</SectionLink> below.
      </P>
    </HelpSectionCard>
  );
}
